/* Amilo PDP helpers. Only loaded on the badematte template. Scrolling to the offer comes from noreno-pdp.js.
   Does not touch cart, Kaching or checkout logic. */
(function () {
  if (window.__amiloPdpLoaded) return;
  window.__amiloPdpLoaded = true;

  // Colour and size sit above the form here, so offer buttons must land on the picker (or Kaching once placed).
  // Runs after noreno-pdp.js, so this final scroll target wins.
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('[data-noreno-scroll-offer], #stickyAddToCartBtn[data-button-behavior="scroll_to_section"]')) return;
      var target = document.querySelector('kaching-bundle') || document.querySelector('.simple-variant-picker');
      if (!target) return;
      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    },
    true
  );

  function init(root) {
    root.querySelectorAll('[data-am-compare]').forEach(function (el) {
      if (el.__am) return;
      el.__am = true;
      var buttons = Array.from(el.querySelectorAll('[data-am-col]'));
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          el.setAttribute('data-active', b.getAttribute('data-am-col'));
          buttons.forEach(function (other) {
            other.setAttribute('aria-pressed', other === b ? 'true' : 'false');
          });
        });
      });
    });

    root.querySelectorAll('[data-am-rail]').forEach(function (el) {
      if (el.__am) return;
      el.__am = true;
      var track = el.querySelector('[data-am-track]');
      var nav = el.querySelector('.am-rv__nav');
      function syncNav() {
        nav.style.visibility = track.scrollWidth > track.clientWidth + 1 ? 'visible' : 'hidden';
      }
      syncNav();
      window.addEventListener('resize', syncNav, { passive: true });
      el.querySelectorAll('[data-am-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: step * parseInt(b.getAttribute('data-am-dir'), 10), behavior: 'smooth' });
        });
      });
    });

    var reveal = root.querySelectorAll('.am-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      reveal.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px' }
    );
    reveal.forEach(function (el) {
      io.observe(el);
    });
  }

  document.documentElement.classList.add('am-js');
  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
